import  { useRef, useState } from "react";
import { Box, TextField, Button } from "@mui/material";
import logo from "../../Assets/logo.svg";
import { toast, ToastContainer } from "react-toastify";
import { verifyOtp } from "../../Services/LoginApi";
import { useNavigate, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid2";

const VerifyOtp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const inputsRef = useRef<any>([]);
  const email = location?.state?.email;

  const handleOtpChange = (value: any, index: any) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (index < 6 && index < otp.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleSubmitOtp = async (values: any) => {
    const otpCode = otp.join("");
    if (otpCode.length < 6) {
      toast.error("Please enter all 6 digits of the OTP!");
      return;
    }
    setLoading(true);
    try {
      const response = await verifyOtp(email, otpCode);
      if (response.success) {
        toast.success(response.message || "OTP verified successfully!");
        navigate("/set-password", { state: { email, otpCode } });
      } else {
        toast.error(response.error || "Failed to reset password.");
      }
    } catch (error) {
      toast.error("Error processing your request. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleKeyDown = (e: any, index: any) => {
    if (e.key === 'Backspace') {
      if (otp[index] === '') {
        if (index > 0) {
          inputsRef.current[index - 1].focus();
        }
      } else {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }
  }

  const handlePaste = (e: any) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("Text").trim();
    if (/^\d+$/.test(pasteData)) {
      const pasted = pasteData.slice(0, otp.length).split("");
      const newOtp = [...otp];
      pasted.forEach((digit: any, i: any) => {
        newOtp[i] = digit;
        if (inputsRef.current[i]) {
          inputsRef.current[i].value = digit;
        }
      });
      setOtp(newOtp);
      if (inputsRef.current[pasted.length - 1]) {
        inputsRef.current[pasted.length - 1].focus();
      }
    }
  };

  return (
    <Box sx={{ flexGrow: 1, overflowY: "auto", overflowX:'hidden' }}>
      <Grid container spacing={2} className="login">
        <Grid
          size={{ xs: 12, md: 5, sm: 12 }}
          className="login__left"
          sx={{ display: { xs: "none", sm: "none", md: "flex" } }}
        >
          <div className="login__left-image">
            <img src={logo} alt="logo" />
          </div>
          <div className="login__left-title">
            <p>Experience Management Portal</p>
          </div>
        </Grid>

        <Grid size={{ xs: 12, md: 7, sm: 12 }} className="login__right">
          <div className="login__container login_main">
            <Grid
              size={{ xs: 12, md: 5, sm: 12 }}
              className="login__left"
              sx={{ display: { xs: "block", sm: "block", md: "none" } }}
            >
              <div className="login__left-image">
                <img src={logo} alt="logo" />
              </div>
              <div className="login__left-title">
                <p>Experience Management Portal</p>
              </div>
            </Grid>

            <h1>Verify OTP</h1>
            <p className="mb-4">
              Enter the 6-digit OTP sent to your registered email address.
            </p>
            <div className="login__form">
              <Box
                sx={{ display: "flex", justifyContent: "center", mb: 3 ,gap:"10px", }}
              >
                {otp.map((digit, index) => (
                  <div className="verify_otp" key={index}>
                    <TextField
                     fullWidth
                      variant="outlined"
                      type="text"
                      inputProps={{
                        maxLength: 1,
                        style: { textAlign: "center", width: '26px'  },
                      }}
                      inputRef={(el) => (inputsRef.current[index] = el)}
                        value={digit}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                        onPaste={handlePaste}
                    
                    />
                  </div>
                ))}
              </Box>

              <div className="login__button">
                <Button
                  onClick={handleSubmitOtp}
                  disabled={loading}
                  variant="contained"
                >
                  {loading ? "Submitting..." : "SUBMIT OTP"}
                </Button>
              </div>

              <ToastContainer position="top-right" autoClose={3000} />
            </div>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VerifyOtp;
